/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterTypeOfRiskKind = (typeof FilterTypeOfRiskKind)[keyof typeof FilterTypeOfRiskKind];

export const FilterTypeOfRiskKind = {
  type_of_risk: 'type_of_risk',
} as const;
